/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import {
  Form,
  Col,
  Row,
  Select,
  Table,
  Button,
  Checkbox,
  Modal,
} from "antd";
import type { UploadProps } from "antd/es/upload/interface";
import { CreateModal } from "./create-modal";
import { EditModal } from "./edit-modal";
import { useRef, useState } from "react";
import { department, unitTSN } from "../../../../info-technology-process/data";
import { useSelector } from "../../../../../../store/store";
import type { ColumnsType } from "antd/es/table";
import { Routes } from "../../../../../../AppRoutes";
import { useHistory } from "react-router-dom";
import { CreateNotification } from "../../../../../../components/notifier";
import { Upload, DatePicker } from "antd";
import { IMaterialType } from "../../models";
import {
  getDDMMYYYFormat,
  getHHmmFormat,
} from "../../../../../../helper/dateTimeHelper";
import { getEnv } from "../../../../../../AppConfigs";
import { MailService } from "../../../../../../services/mail/mail.service";
import { mailRegexs } from "../../../../../../constants/mailTemplateConstants";
import { additionalFormFields, eContent } from "../../constant/field-names";
import { HOChangePersonRequestService } from "../../../../../../services/human-organization/change-person-request.service";
import { requestStatus } from "../../../../../../constants";
import { useExcelTemplate } from "../../../../../../components/input/arrayData/hooks/useExcelTemplate";
import { getTemplate } from "../../../../../../components/input/arrayData/excel-template";
import ExcelJS from "exceljs";
import { StyledTitle } from "../../../../../../components/styled-antd/Title";
import { AlternateApproverSelect } from "../../../../../../components";
import { StyledButton } from "../../../../../../components/styled-antd";
import { RenderHelper } from "../../../summary-employee-request/utils/render-helper";
import { formFields } from "../../constant/field-names";
import { getEmployeeDetail } from "../../../summary-employee-request/utils/get-employee-detail";
import { useSoftwares } from "../../../../../../hook";
import { SystemCode } from "../../../../../../constants";
import { isNoiBai } from "../../utils";
import { HiOutlineTrash } from "react-icons/hi2";
import { eApproveTitleCode } from "../../../../../../constants/bizTitle";
import _ from "lodash";

const { RangePicker } = DatePicker;

export function CreateForm() {
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [fileList, setFileList] = useState<any[]>([]);
  const [pickedUser, setPickedUser] = useState("");
  const [allValue, setAllValue] = useState({});

  const { getITLeadITHeadAssignee } = useSoftwares();

  const history = useHistory();

  const [form] = Form.useForm();

  const employees = useSelector((state: any) => state.employee.employees).map(
    (value: any) => {
      return {
        ...value,
        label: value.Title + " | " + value.eMail,
        value: value.eMail + "|" + value.Title,
      };
    }
  );
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);

  const [employeeOptions, setEmployeeOptions] = useState(employees);

  const onValuesChange = (changedValues: any, allValues: any) => {
    if (changedValues.eDepartment) {
      const selectedDepartmentValue = department.find(
        (e: any) => e.value === changedValues.eDepartment
      );
      const newEmployees = [...employees];

      setEmployeeOptions(
        newEmployees.filter(
          (value) =>
            eApproveTitleCode.indexOf(value.eBizTitleCode) > -1 &&
            value.eDepartmentCode == selectedDepartmentValue?.id
        )
      );

      form.setFieldsValue({
        eApprovedBy: null,
        pickedUser: null,
      });
    }
  };

  const mailtemplates = useSelector(
    (state: any) => state.systemMgmt.mailtemplates
  );
  const approver = useRef("");

  const { exportFile } = useExcelTemplate();
  const [isMultiDelete, setIsMultiDelete] = useState(false);


  const columns: ColumnsType<IMaterialType> = [
    {
      title: isMultiDelete ? (
        <Checkbox
          onClick={(e: any) => {
            if (e.target.checked) {
              setListDelete(_.range(0, dataSource.length));
            } else {
              setListDelete([]);
            }
          }}
        />
      ) : (
        ""
      ),
      dataIndex: "action",
      key: "action",
      render: (value: any, record: IMaterialType, index: number) => {
        index = (currentPage - 1) * pageSize + index;

        if (isMultiDelete) {
          return (
            <Checkbox
              checked={listDelete.includes(index)}
              onChange={(e) => {
                if (e.target.checked) {
                  let newListDelete = [...listDelete, index];
                  setListDelete(newListDelete);
                } else {
                  let newListDelete = [...listDelete];
                  newListDelete = newListDelete.filter(
                    (value): any => value != index
                  );
                  setListDelete(newListDelete);
                }
              }}
            />
          );
        }

        return (
          <div className="d-flex">
            <EditModal
              dataSource={dataSource}
              setDataSource={setDataSource}
              index={index}
              parentValues={form.getFieldsValue()}
            />

            <Button
              onClick={() => {
                const NUM_PAGES = Math.ceil(dataSource.length / pageSize);
                if ((dataSource.length - 1) % 10 == 0) {
                  if (currentPage >= 2 && currentPage === NUM_PAGES)
                    setCurrentPage(currentPage - 1);
                }

                setDataSource((prev) => {
                  return prev.filter(
                    (value, indexValue) => indexValue != index
                  );
                });
              }}
              className="ml-1"
            >
              <HiOutlineTrash
                size={20}
                className="cursor-pointer"
                color="#dc2626"
              />
            </Button>
          </div>
        );
      },
    },
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (value: any, record: IMaterialType, index: number) => (
        <>{(currentPage - 1) * pageSize + index + 1}</>
      ),
    },
    {
      title: "Nhân sự/ mã NV đã đăng ký",
      dataIndex: eContent.registerPersonel,
      key: eContent.registerPersonel,
    },
    {
      title: "Nhân sự/ mã NV thay thế/ bổ sung",
      dataIndex: eContent.replacePersonel,
      key: eContent.replacePersonel,
    },
    {
      title: "Cơ quan/ Đơn vị",
      dataIndex: eContent.department,
      key: eContent.department,
    },
    {
      title: "Lý do thay đổi",
      dataIndex: eContent.reason,
      key: eContent.reason,
    },
    {
      title: "Ghi chú",
      dataIndex: eContent.note,
      key: eContent.note,
    },
  ];

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: async (file) => {

      if(file.name.split(".")[file.name.split(".").length -1] != "xlsx"){
        CreateNotification({
          title: "Import file thất bại",
          body: `File sai định dạng`,
          icon: "/icons/error.png",
        });
        return;
      } 

      const workbook = new ExcelJS.Workbook();
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = async () => {
        const buffer: any = reader.result;
        const workbooks = await workbook.xlsx.load(buffer);

        let data: any[] = [];

        workbooks.eachSheet((sheet, sheetId) => {
          sheet.eachRow((row: any, rowIndex) => {
            data.push([...row.values].filter((value, index) => index != 0));
          });
        });

        data = data.filter((value, index) => index != 0);

        const dataSource: any[] = [];

        for (const item of data) {
          // if (!Array.isArray(item) || item.length != 5) {
          //   CreateNotification({
          //     title: "Import file thất bại",
          //     body: `Vui lòng download biểu mẫu và nhập đúng thông tin.`,
          //     icon: "/icons/error.png",
          //   });
          //   return;
          // }

          dataSource.push({
            [eContent.registerPersonel]: item[0],
            [eContent.replacePersonel]: item[1],
            [eContent.department]: item[2],
            [eContent.reason]: item[3],
            [eContent.note]: item[4],
          });
        }

        setDataSource((prev) => [...prev, ...dataSource]);
        setFileList([...fileList, file]);
      };

      return false;
    },
    fileList,
    showUploadList: false,
    accept:".xlsx"
  };

  const siteUrl = getEnv("REACT_APP_APPROVER_CHANGE_PERSON");

  const sendMail = async (
    approver: any,
    itRepairToolRequest: any,
    type: string
  ) => {
    const url = siteUrl + "/details/" + itRepairToolRequest.id;
    const arr = approver.split("|");
    const tomail = arr.length > 0 ? arr[0] : "";
    const name = arr.length > 1 ? arr[1] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === type);
    const content = template.eContent
      .replace(mailRegexs.zero + ";", name)
      .replace(mailRegexs.one + ";", "duyệt")
      .replace(
        mailRegexs.two + ";",
        itRepairToolRequest.createdBy.user.displayName
      )
      .replace(
        mailRegexs.three + ";",
        `${getDDMMYYYFormat(
          itRepairToolRequest.createdDateTime
        )} - ${getHHmmFormat(itRepairToolRequest.createdDateTime)}`
      )
      .replace(mailRegexs.siteUrl, url);
    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(
      subject,
      content,
      "html",
      tomail
    );
    await MailService.sendMail(message);
  };

  const onFinish = async (values: any) => {
    if (dataSource.length === 0) {
      CreateNotification({
        title: "Thất bại",
        body: `Vui lòng nhập các thông tin yêu cầu`,
        icon: "/icons/error.png",
      });
      return;
    }

    try {
      let initFields: any = {
        Title: "THAY ĐỔI/ BỔ SUNG NHÂN SỰ KHÓA HỌC",

        eDepartment: values.eDepartment,
        // eDepartmentID: department
        //   .filter((value: any) => value.value == values.eDepartment)[0]
        //   ?.id?.toString(),

        eUnit: values.eUnit,
        eUnitID: unitTSN
          .filter((value: any) => value.value == values.eUnit)[0]
          ?.id?.toString(),

        eCourse: values.eCourse,
        eCourseDate: values.eCourseStartEndDate[0],
        eCourseDateEnd: values.eCourseStartEndDate[1],
        eMajor: values.eMajor,

        eRequestStatus: requestStatus.submitted,
        eApprovedStatus: requestStatus.submitted,
        eApprovedByITLeadStatus: requestStatus.submitted,
        eApprovedByITHeadStatus: requestStatus.submitted,
        eAssigneeStatus: requestStatus.submitted,

        eContent: JSON.stringify(dataSource),
        eApprovedBy: approver.current
          ? approver.current.split("|")?.[0]
          : values.eApprovedBy.split("|")?.[0],

          eApprovedByITLead: isNoiBai(values?.eDepartment)
          ? getITLeadITHeadAssignee(SystemCode.CPR).eAssignee.split("|")[0]
          : getITLeadITHeadAssignee(SystemCode.CPR).eApprovedByITLead.split(
              "|"
            )[0],
        eApprovedByITHead: isNoiBai(values?.fields?.eDepartment)
          ? getITLeadITHeadAssignee(SystemCode.CPR).eAssignee.split("|")[0]
          : getITLeadITHeadAssignee(SystemCode.CPR).eApprovedByITHead.split(
              "|"
            )[0],
        eAssignee: getITLeadITHeadAssignee(SystemCode.CPR).eAssignee.split(
          "|"
        )[0],
      };

      formFields.forEach((value, index) => {
        initFields[value.field] = values[value.field];
      });

      additionalFormFields.forEach((value, index) => {
        initFields[value.field] = values[value.field];
      });

      const resp = await HOChangePersonRequestService.addChangePersonRequest({
        fields: {
          ...initFields,
        },
      });

      sendMail(
        `${approver.current ? approver.current : values.eApprovedBy}|${
          getEmployeeDetail(
            approver.current ? approver.current : values.eApprovedBy,
            employees,
            softwares
          )?.[0]?.Title
        }`,
        resp,
        "CPRA"
      );

      CreateNotification({
        title: "Thành công",
        body: `Tạo phiếu yêu cầu thành công`,
        icon: "/icons/success.png",
      });
      history.push(Routes.courseStaffPage.path);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Tạo phiếu yêu cầu thất bại`,
        icon: "/icons/error.png",
      });
      history.push(Routes.courseStaffPage.path);
    }
  };

  const downLoad = async () => {
    await exportFile(getTemplate("change-person"));
  };

  
  const [listDelete, setListDelete] = useState<number[]>([]);
  const confirmDelete = () => {

    const NUM_PAGES = Math.ceil(dataSource.length / pageSize);
    if ((dataSource.length - listDelete.length) % 10 == 0) {
      if (currentPage >= 2 && currentPage === NUM_PAGES)
        setCurrentPage(currentPage - 1);
    }

    let newDataSource = [...dataSource];
    newDataSource = newDataSource.filter(
      (value, index) => !listDelete.includes(index)
    );
    setDataSource(newDataSource);
    
    setListDelete([]);
    setIsMultiDelete(false);
  };

  const showDeleteConfirm = () => {
    Modal.confirm({
      title: "Thông báo",
      content: "Anh/chị vui lòng xác nhận xoá các dữ liệu đã chọn!",
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      onOk() {
        confirmDelete();
      },
    });
  };

  const pageSize = 10; // Number of rows per page
  const [currentPage,setCurrentPage] = useState(1)

  return (
    <>
      <Form
        onFinish={onFinish}
        size="large"
        form={form}
        onValuesChange={onValuesChange}
      >
        <Row gutter={[32, 0]}>
          <Col span={12}>
            <StyledTitle level={5}>
              Cơ quan/ Đơn vị <span className="text-danger">(*)</span>
            </StyledTitle>
            <Form.Item
              name="eDepartment"
              rules={[{ required: true, message: "Chọn cơ quan đơn vị" }]}
            >
              <Select options={department} placeholder="Chọn Cơ quan/Đơn vị" />
            </Form.Item>
          </Col>

          <RenderHelper
            allValue={allValue}
            setAllValue={setAllValue}
            form={form}
            fields={formFields}
          />

          <Col span={12}>
            <StyledTitle level={5}>
              Chọn ngày <span className="text-danger">(*)</span>
            </StyledTitle>
            <Form.Item
              name="eCourseStartEndDate"
              rules={[{ required: true, message: "Chọn ngày" }]}
            >
              <RangePicker
                style={{ width: "100%" }}
                placeholder={["Từ ngày", "Đến ngày"]}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col>
            <StyledTitle level={5}>
              Chi tiết <span className="text-danger">(*)</span>
            </StyledTitle>
          </Col>
        </Row>

        <Row>
          <Col>
            <CreateModal
              dataSource={dataSource}
              setDataSource={setDataSource}
              parentValues={form.getFieldsValue()}
            />
          </Col>

          <Col>
            {!isMultiDelete && (
              <Button
                className="ml-3"
                type="primary"
                danger
                onClick={() => setIsMultiDelete(true)}
              >
                Chọn nhiều để xóa
              </Button>
            )}

            {isMultiDelete && (
              <StyledButton
                className="ml-3"
                bgColor="green"
                onClick={() => {
                  setIsMultiDelete(false);
                  setListDelete([]);
                }}
              >
                Quay lại
              </StyledButton>
            )}

            {listDelete.length != 0 && (
              <Button
                className="ml-3"
                type="primary"
                onClick={showDeleteConfirm}
                danger
              >
                Xóa dữ liệu đã chọn
              </Button>
            )}
          </Col>

          <Col>
            <Upload {...props}>
              <StyledButton bgColor="blue" className="mx-3">
                Tải biểu mẫu{" "}
              </StyledButton>
            </Upload>
          </Col>

          <Col>
            <div className="mt-1">
              <a href="#" className="text-primary" onClick={downLoad}>
                Download biểu mẫu tại đây
              </a>
            </div>
          </Col>
        </Row>

        <div style={{ overflowX: "scroll" }}>
          <Table
            dataSource={[...dataSource]}
            columns={columns}
            pagination={{
              onChange: (page) => {
                setCurrentPage(page);
              },
              current: currentPage,
            }}
          />
        </div>

        <Row gutter={[32, 0]}>
          <RenderHelper fields={additionalFormFields} />
        </Row>

        <Row gutter={[32, 0]}>
          <Col span={12}>
            <StyledTitle level={5}>
              Người duyệt{" "}
              {pickedUser === "" && <span className="text-danger">(*)</span>}
            </StyledTitle>
            <Form.Item
              name="eApprovedBy"
              rules={[
                { required: pickedUser === "", message: "Chọn người duyệt" },
              ]}
            >
              <Select
                options={employeeOptions}
                onChange={(value) => {
                  approver.current = value;
                }}
                placeholder="Thủ trưởng CQ/ĐV"
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <StyledTitle level={5}>Người duyệt thay thế</StyledTitle>
            <AlternateApproverSelect
              placeholder="Thủ trưởng CQ/ĐV"
              onChange={(value) => {
                if (value) {
                  approver.current = value.split("|")?.[0]?.toLowerCase() || "";

                  setPickedUser(value.split("|")?.[0]?.toLowerCase() || "");
                }
              }}
            />
          </Col>

          <Col span={24}>
            <div className="d-flex justify-content-center">
              <StyledButton
                bgColor="red"
                htmlType="submit"
                onClick={() => history.push(Routes.courseStaffPage.path)}
                danger
                type="primary"
              >
                Hủy
              </StyledButton>

              <StyledButton
                bgColor="yellow"
                type="primary"
                htmlType="submit"
                className="ml-3"
              >
                Xác nhận
              </StyledButton>
            </div>
          </Col>
        </Row>
      </Form>
    </>
  );
}
